module.exports = __webpack_public_path__ + "static/media/video-breathing-ms.1b03f315.vtt";